module.exports = __webpack_public_path__ + "static/media/Telecommunications.7ea7e311.jpeg";